import type { CorvidSDKFactory } from '@wix/editor-elements-types/corvid';

export const createVisibilitySdk: CorvidSDKFactory = api => {
  const { props, setProps } = api;
  return {
    get hidden() {
      return props?.isHidden || props?.hidden || false;
    },

    show() {
      setProps({ hidden: false });
    },

    hide() {
      setProps({ hidden: true });
    },
  };
};
